import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

import { PodcastEpisode } from 'types';

import { podcastEpisode as episodeFragment } from './fragments';
import { Loadable, Loaded, NotLoaded, NotFound } from './util';

const getPodcastEpisodes = ({
  podcastShowSlug,
  offset,
  limit,
}: {
  podcastShowSlug: string;
  offset?: number;
  limit?: number;
}): Loadable<Array<PodcastEpisode<'podcastShow'>>> => {
  const { data, loading } = useQuery(
    gql`
    query GetPodcastEpisodes($podcastShowSlug: String!, $offset: Int, $limit: Int) {
      podcastEpisodes(podcastShowSlug: $podcastShowSlug, offset: $offset, limit: $limit) {
        ${episodeFragment}
      }
    }
  `,
    {
      variables: { podcastShowSlug, offset, limit },
    },
  );
  if (data === undefined || loading) {
    return NotLoaded;
  }
  return Loaded(data.podcastEpisodes);
};

const episodeBySlugQuery = (slug: string) => {
  return gql`
    query PodcastEpisodeBySlug {
      
    podcastEpisode(slug:"${slug}") {
        ${episodeFragment}
      }
    }
  `;
};

const getBySlug = (slug: string): Loadable<PodcastEpisode<'podcastShow'>> => {
  const { data } = useQuery(episodeBySlugQuery(slug));
  if (data === undefined) {
    return NotLoaded;
  }
  if (data.podcastEpisode === null) {
    return NotFound;
  }
  return Loaded(data.podcastEpisode);
};

export { getBySlug, getPodcastEpisodes };
